import {ValueObject} from '@s-ui/domain'

export class SendComplaintAdsRequestValueObject extends ValueObject {
  constructor({adId, complaintTypeId, comments, email, name}) {
    super()
    this._adId = adId
    this._complaintTypeId = complaintTypeId
    this._comments = comments
    this._email = email
    this._name = name
  }

  static validate({adId, complaintTypeId, invalidParamsError} = {}) {
    if (!adId || !complaintTypeId) {
      throw invalidParamsError.create(`[SendComplaintAdsRequestValueObject] Bad request parameters`)
    }
  }

  getAdId() {
    return this._adId
  }

  getBody() {
    return {
      type: this._complaintTypeId,
      ...(this._comments && {comment: this._comments}),
      ...(this._email && {email: this._email}),
      ...(this._name && {name: this._name})
    }
  }
}
